import React from 'react'
import { connect } from 'react-redux'
import { keys, sortBy } from 'lodash'
import { Link } from 'react-router-dom'
import Autocomplete from 'react-autocomplete'
import Select from 'react-select';

import { setSelectedCountry, setComparisonCountry, setColorMode, setCountryMode } from '../../state/actions'

import './index.css'

const mapStateToProps = state => ({
  countries: state.countries,
  selectedCountry: state.selectedCountry,
  colorMode: state.colorMode,
  countryMode: state.countryMode,
})

const mapDispatchToProps = { setSelectedCountry, setComparisonCountry, setColorMode, setCountryMode }

const menuStyle ={
  backgroundColor: 'none',
  padding: '2px 0',
  position: 'fixed',
  overflow: 'auto',
  maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
  color: "#222",
}

class CountrySelector extends React.Component {

  state = {
    value: '',
  }

  render(){

    const { items, countries, setSelectedCountry, selectedCountry } = this.props
    const value = selectedCountry ? countries[selectedCountry] : this.state.value

    return (

      <Autocomplete
         inputProps={ {className: "CountrySelector__Autocomplete background-blue w-100 bb", placeholder:"Search for a country"} }
         wrapperProps={ {className: "w-100"} }
         menuStyle={menuStyle}
         getItemValue={(item) => item.value}
         items={items}
         shouldItemRender={(item, value)=>{ return item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1 }}
         renderItem={(item, isHighlighted) =>
           <div className="background-blue text-white pa1"
            //  style={{ background: isHighlighted ? 'lightgray' : '#222' }}
             >
             {item.label}
           </div>
         }
         value={value}
         onChange={(e) => this.setState({value:e.target.value}) }
         onSelect={(val) => {
           setSelectedCountry(val)
         } }

       />
    )

  }

}

const CountrySelectorConnected = connect(mapStateToProps, mapDispatchToProps)(CountrySelector)


const colorModeOptions = [
  { value: 'performance', label: 'Performance'},
  { value: 'continent', label: 'Continent'},
]

const countryModeOptions = [
  { value: 'all', label: 'All countries'},
  { value: 'top', label: 'Top 25'},
  { value: 'bottom', label: 'Last 25'},
]

const countryModeOptionsSort = [
  { value: 'all', label: 'Alphabetically'},
  { value: 'top', label: 'Best first'},
  { value: 'bottom', label: 'Worst first'},
]


class TrendFacilitationHeader extends React.Component {

  handleColorModeChange = (item) => {
    this.props.setColorMode(item.value)
  }

  handleCountryModeChange = (item) => {
    this.props.setCountryMode(item.value)
  }

  render() {

    const { selectedCountry, countries, setSelectedCountry, setComparisonCountry, colorMode, setColorMode,
      countryMode, setCountryMode, hasShowSort=true, showSortMode='show'} = this.props

    if(!countries){
      return null
    }

    const countryCodes = keys(countries)
    const items = sortBy(
        countryCodes.map(code => ({label:countries[code], value:code})),
        'label'
      )
    const showSortTitle = showSortMode === 'show' ? 'SHOW' : 'SORT'

    return (
      <div className="background-blue text-white relative">
        <div className="h-container cf TrendFacilitationHeader">
        <div className="fl-l w-100 w40-l">
          <div className="fl w-third pa3">

          <div>SELECT COUNTRY</div>
              <div className="w-100" style={{paddingTop:1}}>
              { selectedCountry===null && (
                <CountrySelectorConnected items={items}/>
              )}
              { selectedCountry!==null && (
                <div style={{padding:'8px 0px'}} className="cf bb">
                <span style={{cursor:'pointer', marginRight: 5}} className="fl"
                    onClick={()=>{
                      setSelectedCountry(null);
                      setComparisonCountry(null);
                    }}>x</span>
                  <span className="fl">{countries[selectedCountry]}</span>
                </div>
              )}
            </div>
          </div>

          <div className="fl w-third pa3">
            COLOUR
            <Select
              className="TopSelect"
              name="select_colormode"
              value={colorMode}
              clearable={false}
              options={colorModeOptions}
              onChange={this.handleColorModeChange}
            />
          </div>
          {hasShowSort && <div className="fl w-third pa3">
            {showSortTitle}
            <Select
              className="TopSelect"
              name="select_countrymode"
              value={countryMode}
              clearable={false}
              options={showSortMode === 'show' ? countryModeOptions : countryModeOptionsSort}
              onChange={this.handleCountryModeChange}
            />
          </div>}
        </div>
        </div>
      </div>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(TrendFacilitationHeader)



// WEBPACK FOOTER //
// ./src/components/TrendFacilitationHeader/index.js